import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../auth/AdminAuthContext";
import { AdminRole } from "../../types/adminAuth";

export default function RequireAdminRole({
  roles,
  children,
}: {
  roles: AdminRole[];
  children: React.ReactElement;
}) {
  const { loading, isAuthenticated, user } = useAdminAuth();

  if (loading) {
    return <div style={{ padding: 20 }}>Checking permissions...</div>;
  }
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }
  if (!roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
